<template>
  <circle-button
    icon="mdi-printer"
    @click="$emit('click')"
    color="primary"
    :small="small"
    :tooltip="$t('print')"
  />
</template>

<script>
export default {
  name: "GlobalButtonPrint",
  props: {
    color: {
      type: String,
      default: "primary",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
